module.exports = __webpack_public_path__ + "img/visa.46336c7d.svg";